import classNames from 'classnames';

export const FOCUS_CLASS_NAME =
  'outline-none focus-visible:ring-3 focus-visible:ring-accent-fill';

export const BUTTON_TEXT_CLASS_NAME = 'normal-case tracking-normal';

export const CARD_CLASS_NAME =
  'rounded-[16px] bg-surface shadow-soft ring-1 ring-hairline';

const BUTTON_CLASS_NAME =
  'flex h-[48px] shrink-0 items-center justify-center gap-[8px] rounded-[14px] px-[18px] disabled:bg-control disabled:text-ink-muted';

export const PRIMARY_BUTTON_CLASS_NAME = classNames(
  BUTTON_CLASS_NAME,
  'bg-accent-fill text-[16px] font-bold text-accent-on outline-none focus-visible:ring-3 focus-visible:ring-accent-ring'
);

export const SECONDARY_BUTTON_CLASS_NAME = classNames(
  BUTTON_CLASS_NAME,
  'bg-control text-[14px] font-semibold text-ink',
  FOCUS_CLASS_NAME
);

export const DANGER_BUTTON_CLASS_NAME = classNames(
  BUTTON_CLASS_NAME,
  'bg-danger text-[14px] font-bold text-white',
  FOCUS_CLASS_NAME
);

export const ICON_BUTTON_CLASS_NAME = classNames(
  'flex size-[44px] shrink-0 items-center justify-center rounded-[12px] bg-transparent text-ink',
  FOCUS_CLASS_NAME
);

export const OVERLAY_CLASS_NAME =
  'fixed inset-0 flex items-center justify-center bg-black/40 p-[16px]';

export const DIALOG_CLASS_NAME =
  'flex max-h-full w-full max-w-[340px] flex-col rounded-[20px] bg-surface p-[20px] text-ink shadow-dock';
